import React from 'react'
import PropTypes from 'prop-types'

import './Logo.scss'

const Logo = ({ logo, scene }) => (
  <div id={`fi_logo-${scene}`} className={`fi_logo fi_logo-${scene}`} style={{ backgroundImage: `url(${logo})` }} />
)

Logo.propTypes = {
  logo: PropTypes.string,
  scene: PropTypes.number
}

export default Logo



// WEBPACK FOOTER //
// ./src/templates/fashionIcon/components/Logo.js